/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/
import LockIcon from "@mui/icons-material/Lock";

const routes = [
  {
    type: "collapse",
    name: "Perfil de usuario",
    key: "perfil",
    //allow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17, 18, 19, 20, 21, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    route: "/",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Requisición",
    key: "requisicion",
    //allow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17, 18, 19, 20, 21, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    route: "/requisicion",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Ordenes de Compra",
    key: "orden-compra",
    allow: [73, 65, 79, 58],
    route: "/orden-compra",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Proveedores",
    key: "proveedores",
    allow: [73, 65, 79, 58],
    route: "/proveedores",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Empresas",
    key: "empresas",
    allow: [73, 65, 79, 58],
    route: "/empresas",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Cotizaciones",
    key: "cotizaciones",
    allow: [73, 65, 79, 58],
    route: "/cotizaciones",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Kardex",
    key: "kardex",
    allow: [73, 65, 79, 58],
    route: "/kardex",
    iconText: "Lock",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Inventarios",
    key: "inventarios",
    allow: [73, 65, 79, 58],
    //icon: <LockIcon />,
    iconText: "Lock",
    collapse: [
      {
        name: "Catálogo de productos",
        icon: "GroupIcon",
        key: "catalogo-productos",
        route: "/catalogo-productos",
        allow: [73, 65, 79, 58],
      },
      {
        name: "Categorias",
        icon: "GroupIcon",
        key: "categorias",
        route: "/categorias",
        allow: [73, 65, 79, 58],
      },
      {
        name: "Tipos de Producto",
        icon: "GroupIcon",
        key: "tipos-producto",
        route: "/tipos-producto",
        allow: [73, 65, 79, 58],
      },
      {
        name: "Unidades de Medida",
        icon: "GroupIcon",
        key: "unidades-medida",
        route: "/unidades-medida",
        allow: [73, 65, 79, 58],
      },
      {
        name: "Ubicaciones",
        icon: "GroupIcon",
        key: "ubicaciones",
        route: "/ubicaciones",
        allow: [73, 65, 79, 58],
      },
      {
        name: "Almacenes",
        icon: "GroupIcon",
        key: "almacenes",
        route: "/almacenes",
        allow: [73, 65, 79, 58],
      },
    ],
  },
];

export default routes;
